import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import {
  AppBar, Toolbar, Container, Typography, Box, IconButton,
  TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';
import imperial_conchas_logo from "./Assets/SVG_assets-08.svg";
import imperial_logo from "./Assets/SVG_assets-01.svg";
import fondoDesktop from "./Assets/BG_Desktop.png";
import fondoMobile from "./Assets/BG_Mobile.png";
import iconoCarga from "./Assets/SVG_assets_shell.svg";
import deleteImage from "./Assets/SVG_assets-13.svg";
import iconoTitulo from './Assets/SVG_assets-02.svg';
import iconoIngreso from './Assets/SVG_assets-05.svg';
import iconoUsuario from './Assets/SVG_assets-10.svg';
import iconoContrasena from './Assets/SVG_assets-11.svg';
import cajaClasificacion from './Assets/SVG_assets-12.svg';



const EntryContainer = styled(Container)(({ background }) => ({
  background: `url(${background}) no-repeat center center fixed`,  // Position and fix the background
  backgroundSize: 'cover',  // Ensure the background covers the entire container
  color: 'black',
  position: 'fixed',  // ✅ Allows the AppBar to be on top
  marginLeft: 'auto',
  marginRight: 'auto',
  minWidth: "100%",
  minHeight: "99vh",
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 'calc(10px + 2vmin)',
  backgroundColor: 'transparent',
}));

const EntryStyledAppBar = styled(AppBar)(({ theme }) => ({
  background: 'transparent',
  boxShadow: 'none',
  position: 'fixed',  // ✅ Keeps the AppBar on top
  top: 0,
  left: 0,
  width: '100%',
  maxHeight: '10vh',
  zIndex: 100,  // ✅ Ensures nothing overlaps it
}));

const LoginWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px; // Ajustar si es necesario
  margin: auto; // Centrarlo en la pantalla
`;

// Imagen del título en lugar del texto "Iniciar Sesión"
const LoginTitle = styled('img')`
  width: 200px; // Ajustar tamaño según necesidad
  height: auto;
  margin-bottom: 20px;
`;

// Contenedor del formulario de login
const LoginForm = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  background: none; 
  border-radius: 0; 
  box-shadow: none; 
`;


// Contenedor de los campos de entrada
const InputContainer = styled(Box)`
  display: flex;
  align-items: center;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0)); 
  padding: 0px 10px;
  border-radius: 0px;
  width: 90%;
  max-width: 350px;
  height: 35px;
  margin: 5px 0;
  box-shadow: none !important; 
  padding-bottom: 0; 
`;

// Icono dentro del input
const InputIcon = styled('img')`
  width: 20px;
  height: 25px;
  margin-right: 10px;
`;


const StyledTextField = styled(TextField)`
  flex: 1;
  margin-bottom: -10px;
  color: white !important;


  input {
    color: white !important ;
    background: transparent;
    border: none;
    font-family: 'Personal Industry Inc Inline Stroke Light', sans-serif;
    font-weight: 300;
    text-transform: uppercase;
    text-align: left;
    padding-left: 5px;
    font-size: '10px',
  }

  & ::placeholder {
    color: white !important;
    opacity: 1; /* Para que se vea al 100% */
  }

  label {
    color: white !important;
    font-family: 'Personal Industry Inc Inline Stroke Light', sans-serif;
    font-weight: 300;
    text-align: left;
    padding-left: 15px;
    font-size: '10px',
  }

  & .MuiInput-underline:before,
  & .MuiInput-underline:after {
    display: none !important;
    border-bottom: none !important;
  }

  & .MuiInputBase-root {
    border-bottom: none !important;
    box-shadow: none !important;  
  }

  fieldset {
    border: none !important;
  }
`;



// Imagen del botón de ingreso
const LoginButton = styled('img')`
  padding-top: 25px;
  cursor: pointer;
  width: auto;
  height: 120px;
  margin-top: 25px;
`;

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: 'transparent',
  boxShadow: 'none',
  position: 'fixed',  // ✅ Keeps the AppBar on top
  top: 0,
  left: 0,
  width: '100%',
  maxHeight: '10vh',
  zIndex: 100,  // ✅ Ensures nothing overlaps it
}));



const MainContainer = styled(Container)(({ background }) => ({
  background: `url(${background}) no-repeat center center fixed`,  // Position and fix the background
  backgroundSize: 'cover',  // Ensure the background covers the entire container
  color: 'black',
  position: 'absolute',  // ✅ Allows the AppBar to be on top
  marginLeft: 'auto',
  marginRight: 'auto',
  minWidth: "100%",
  minHeight: "99vh",
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',  
  paddingTop: "0vh",  
  justifyContent: 'center',
  fontSize: 'calc(10px + 2vmin)',
  backgroundColor: 'transparent',
}));

const UploadAndClassificationContainer = styled(Box)`
  position: fixed;  
  top: 450px;
  display: flex;
  margin-right: 0px;
  margin-top: -300px;
  flex-direction: column;
  z-index: 3;
  width: 100%;
  overflow: visible;  /* ✅ Ensures no hidden elements */

  @media (max-width: 768px) {
    top: 320px;         /* Ajusta según necesites */
    margin-top: -140px; /* Ajusta según necesites */
    margin-right: 10px;
  }
`;

const UploadButtonWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky; 
  width: 210px; 
  height: 210px;
  margin: auto;
  border-radius: 0px;
  z-index: 10; /* ✅ Keeps it ABOVE everything else */
  overflow: visible; /* ✅ Ensures corners are not cut */

  /* ✅ Fixes bottom border visibility */
  &::before, &::after, & .corner-bottom-left, & .corner-bottom-right {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    border: 1px solid #FFD700;
  }

  &::before { top: 0; left: 0; border-right: none; border-bottom: none; }
  &::after { top: 0; right: 0; border-left: none; border-bottom: none; }
  & .corner-bottom-left { bottom: 0; left: 0; border-right: none; border-top: none; }
  & .corner-bottom-right { bottom: 0; right: 0; border-left: none; border-top: none; }
`;

const UploadButtonContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '200px',
  height: '200px',
  background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0))',
  borderRadius: '0px',
  textAlign: 'center',
  cursor: 'pointer',
  overflow: 'visible',
  position: 'relative', // ✅ Ensures absolute children are positioned inside
});

const UploadText = styled(Typography)`
  color: #ffffff;
  margin-top: 14px;
  margin-bottom: 4px;
  margin-right: 8px;
  margin-left: 8px;
  font-size: 12px; 
  font-family: 'Personal Industry Inc Inline Stroke Bold'; 
  font-weight: 600; 
  text-shadow: 0.5px 0.5px #000000;
`;

const UploadInfoText = styled(Typography)`
  color: #717A80;
  font-size: 11px;
  margin-right: 5px;
  margin-left: 5px;
  font-family: 'Personal Industry Inc Inline Stroke Light'; 
  font-weight: 300; 
`;

const ClassificationListContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  minwidth: 100vh;
  width: 100%;
  max-height: 230px;      /* Ajusta el valor a tu preferencia */
  overflow-y: auto;  
  margin-top: 1px;   /* ✅ Pushes classifications below the button */
  margin-right: 100px;  /* ✅ Aligns with the upload button */
  z-index: 5;         /* ✅ Keeps it BELOW the upload button */
`;

const ClassificationContainer = styled(Box)`
  position: relative;
  width: 320px;
  height: 100px;
  background: url(${cajaClasificacion}) no-repeat center;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  margin-top: 10px;
  z-index: 2;
`;


const ImageContainer = styled('div')(({ numberOfFiles }) => {
  // Inicialmente definimos un objeto vacío
  let dynamicStyles = {};

  // Usamos lógica condicional
  if (numberOfFiles === 1) {
    dynamicStyles = {
      marginTop: '16px',
      marginLeft: '-3px',
      backgroundColor: 'black',
    };
  } else if (numberOfFiles === 2) {
    dynamicStyles = {
      marginTop: '3px',
      marginLeft: '-1px',
      backgroundColor: 'black',
    };
  } else if (numberOfFiles >= 3) {
    dynamicStyles = {
      marginTop: '3px',
      backgroundColor: 'black',
    };
  }

  // Retornamos un objeto con los estilos base y los estilos dinámicos
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '68px',
    height: '66px',
    border: '1px solid #FFD700',
    borderRadius: 0,
    marginRight: '15px',
    marginLeft: '1px',
    // ... otros estilos que quieras
    ...dynamicStyles,
  };
});


const StyledImage = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ClassificationText = styled(Box)(({ numberOfFiles }) => {
  let dynamicStyles = {};

  // Lógica condicional según el número de archivos
  if (numberOfFiles === 1) {
    dynamicStyles = {
      marginTop: '24px',
    };
  } else if (numberOfFiles === 2) {
    dynamicStyles = {
      marginTop: '12px',
    };
  } else if (numberOfFiles >= 3) {
    dynamicStyles = {
      marginTop: '12px',
    };
  }

  // Retornamos estilos base + estilos dinámicos
  return {
    display: 'flex',
    flexDirection: 'column',
    color: 'white',
    fontSize: '11px',
    flexGrow: 1,
    // Agregamos los estilos calculados
    ...dynamicStyles,
  };
});


const StyledDeleteIcon = styled('img')(({ numberOfFiles }) => {
  let dynamicStyles = {};

  // Lógica condicional según el número de archivos
  if (numberOfFiles === 1) {
    dynamicStyles = {
      marginTop: '-50px',
      marginRight: '6px',
    };
  } else if (numberOfFiles === 2) {
    dynamicStyles = {
      marginTop: '-49px',
      marginRight: '7px',
    };
  } else if (numberOfFiles >= 3) {
    dynamicStyles = {
      marginTop: '-48px',
      marginRight: '11px',
    };
  }

  // Retornas un objeto con estilos base + los dinámicos
  return {
    cursor: 'pointer',
    height: '15px',
    zIndex: 3,
    ...dynamicStyles,
  };
});




export default function App() {

  const [backgroundImage, setBackgroundImage] = useState(
    window.innerWidth < 768 ? fondoMobile : fondoDesktop
  );
  // Manejar cambios en el tamaño de la pantalla
  useEffect(() => {
    const handleResize = () => {
      setBackgroundImage(window.innerWidth < 768 ? fondoMobile : fondoDesktop);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [fileList, setFileList] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, severity: 'info', message: '' });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const logoutTimerRef = useRef(null);
  const fileInputRef = useRef(null); 

  useEffect(() => {
    const isAuth = localStorage.getItem('isAuthenticated');
    const loginTime = localStorage.getItem('loginTime');
    if (isAuth === 'true' && loginTime) {
      const currentTime = Date.now();
      const elapsedTime = currentTime - parseInt(loginTime);
      if (elapsedTime < 28800000) {
        setIsAuthenticated(true);
        const remainingTime = 28800000 - elapsedTime;
        setLogoutTimer(remainingTime);
      } else {
        handleLogout();
      }
    }
  }, []);

  const setLogoutTimer = useCallback((timeout) => {
    clearTimeout(logoutTimerRef.current);
    logoutTimerRef.current = setTimeout(() => {
      handleLogout();
    }, timeout);
  }, []); 

  const handleLogin = () => {
    if (username === "devueltaacasa" && password === "Conchas*2024") {
      const loginTime = Date.now();
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('loginTime', loginTime.toString());
      setIsAuthenticated(true);
      setLogoutTimer(28700000); 
      setSnackbar({ open: true, severity: 'success', message: 'Inicio de sesión exitoso' });
    } else {
      setSnackbar({ open: true, severity: 'error', message: 'Credenciales incorrectas' });
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('loginTime');
    setIsAuthenticated(false);
    clearTimeout(logoutTimerRef.current);
    setSnackbar({ open: true, severity: 'info', message: 'Session expired or logged out' });
  };

  const handleDelete = (uid) => {
    setFileList((prevFileList) => prevFileList.filter((file) => file.uid !== uid));
  };

  const handleUpload = async (file) => {
    const formData = new FormData();
    formData.append('files', file);

    try {
      const response = await axios({
        method: 'post',
        url: '/receive-files',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data) {
        setFileList((prevFileList) =>
          prevFileList.map((f) => {
            if (f.uid === file.uid) {
              return { ...f, classifications: response.data[0], status: 'done' };
            }
            return f;
          }),
        );
        setSnackbar({ open: true, severity: 'success', message: `${file.name} file uploaded successfully` });
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      let errorMessage = `${file.name} file upload failed.`; // Default error message

      if (error.response && error.response.data && error.response.data.detail) {
        errorMessage = `${file.name} file upload failed: ${error.response.data.detail}`;
      }

      setFileList((prevFileList) =>
        prevFileList.filter((f) => f.uid !== file.uid),
      );
      setSnackbar({ open: true, severity: 'error', message: errorMessage });
    }
  };

  const handleBeforeUpload = (file) => {
    const newFile = Object.assign(file, {
      uid: Math.random().toString(36).substr(2, 9),
      status: 'uploading'
    });

    const reader = new FileReader();
    reader.onload = (e) => {
      newFile.preview = e.target.result;
      setFileList((prevFileList) => [newFile, ...prevFileList ]);
      handleUpload(newFile);
    };
    reader.readAsDataURL(file);
  };

  const onFileChange = (event) => {
    const files = Array.from(event.target.files);
    // setFileList([]); // Quitar comentario si se quiere que cada vez que se suba una imagen se borren las anteriores

    files.forEach(file => {
      if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
        handleBeforeUpload(file);
      } else {
        setSnackbar({ open: true, severity: 'error', message: `${file.name} is not a valid image file.` });
      }
    });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  if (!isAuthenticated) {
    return (
      <EntryContainer background={backgroundImage}>
        {/* Navbar Superior */}
        <EntryStyledAppBar>
          <Toolbar>
          <img src={imperial_logo} alt="Logo" style={{ width: 'auto', height: '40px' , marginLeft:'15px'}} />
          </Toolbar>
        </EntryStyledAppBar>
  
        <LoginWrapper>
          {/* Imagen del título en lugar del Typography */}
          <LoginTitle src={iconoTitulo} alt="Iniciar Sesión" />

          {/* Contenedor del formulario */}
          <LoginForm component="form" noValidate autoComplete="off">
            <InputContainer>
              <InputIcon src={iconoUsuario} />
              <StyledTextField
                placeholder="Usuario"
                variant="standard"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </InputContainer>

            <InputContainer>
              <InputIcon src={iconoContrasena} />
              <StyledTextField
                placeholder="Contraseña"
                type="password"
                variant="standard"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </InputContainer>

            {/* Imagen como botón de ingreso */}
            <LoginButton 
              src={iconoIngreso}
              alt="Ingresar"
              onClick={handleLogin}
            />
          </LoginForm>
        </LoginWrapper>
      </EntryContainer>
    );
  }

  return (
    <React.Fragment>
      <MainContainer background={backgroundImage} position="relative">
        <StyledAppBar position="static">
          <Toolbar>
          <img src={imperial_conchas_logo} alt="Logo" style={{ width: 'auto', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}} />
          </Toolbar>
        </StyledAppBar>
        <UploadAndClassificationContainer>
          <UploadButtonWrapper>
            <UploadButtonContainer onClick={() => fileInputRef.current.click()}>
              <img src={iconoCarga} alt="Upload" style={{ width: 'auto', height: '70px', color: '#4A90E2' }} />
              <UploadText variant="body1">
                Arrastrá o hacé click aquí para subir tus archivos
              </UploadText>
              <UploadInfoText>
                Hasta 20 archivos JPG, JPEG y/o PNG
              </UploadInfoText>
              <input
                type="file"
                hidden
                multiple
                accept=".png,.jpeg,.jpg"
                onChange={onFileChange}
                ref={fileInputRef}
              />

            </UploadButtonContainer>
            <span className="corner-bottom-left"></span>
            <span className="corner-bottom-right"></span>
          </UploadButtonWrapper>
          <ClassificationListContainer>
            {fileList.map((file) => (
              <ClassificationContainer key={file.uid}>
                {/* Image inside yellow-bordered box */}
                <ImageContainer numberOfFiles={fileList.length}>
                  <StyledImage src={file.preview} alt="Clasificación" />
                </ImageContainer>

                {/* Classification details */}
                <ClassificationText numberOfFiles={fileList.length}>
                  <div><strong>ZONA:</strong> {file.classifications?.pacific_or_caribe_class || "Desconocida"}</div>
                  <div><strong>CONFIANZA ZONA:</strong> 
                    {file.classifications?.pacific_or_caribe_confidence 
                      ? `${(file.classifications.pacific_or_caribe_confidence * 100).toFixed(2)}%`
                      : "0.00%"}
                  </div>
                </ClassificationText>

                {/* Delete button */}
                <IconButton onClick={() => handleDelete(file.uid)} aria-label="delete">
                  <StyledDeleteIcon numberOfFiles={fileList.length} src={deleteImage} alt="delete" />
                </IconButton>
              </ClassificationContainer>
            ))}
          </ClassificationListContainer>
        </UploadAndClassificationContainer>
      </MainContainer>
    </React.Fragment>
  );
}
